<template>
  <!-- All these styles needs to be changed to classes -->
  <div class="section-content" style="height:calc(100vh - 60px);overflow-y: auto;">

    <div class="primary-section-content pt-4" style="height:100%;">

      <template>
        <hb-modal
          v-model="isModalVisible"
          title="Activity Details"
          title-icon="mdi-account-clock-outline"
          :show-help-link="false"
          :footer-cancel-option="false"
          :footer-top-border="false"
          @close="closeModal"
          class="custom-modal"
        >
          <!-- TODO This is temporary. Move the template -->
          <template v-slot:content>
            <div>
              <div class="mt-3 mx-4 mb-2">
                <span class="font-weight-medium">{{ modalData.data.entity }}</span><span v-if="modalData.data.sub_entity" class="pl-1">- {{ modalData.data.sub_entity }}</span>
              </div>
              <div v-if="modalData.data.category === 'Settings' && modalData.data.action?.trim() && modalData.data.entity_name?.trim()" class="mt-2 mb-4 mx-4">
                <span class="font-weight-medium">{{ modalData.data.action }}</span>: {{ modalData.data.entity_name }}
              </div>
              <div class="mb-3 mx-4">
                {{ modalData.data.property_name }}
              </div>
              <div v-if="!modalData.modified_data || modalData.modified_data.length === 0" class="mx-4">
                <p>No changes detected</p>
              </div>
              <hb-data-table
                v-else
                :headers="modalHeaders"
                :items="modalData.modified_data"
                elevation="0"
              >
                <template v-slot:item.new="{ item }">
                   <span v-if="isSimpleValue(item.new)">
                    <template v-if="item.field === 'Mobile Number'">
                      {{ formatMobileNumber(item.new) }}
                    </template>
                    <template v-else>
                      {{ item.new ?? '-' }}
                    </template>
                  </span>
                  <div v-else-if="Array.isArray(item.new) && item.new.length && typeof item.new[0] === 'object'">
                    <div v-for="(entry, index) in item.new" :key="'new_' + index">
                       <strong>{{ entry.key }}</strong>: 
                       <template v-if="!isHtml(entry.value)">
                        <span>{{ entry.value ?? '-' }}</span>
                      </template>
                      <template v-else>
                        <div v-html="entry.value"></div>
                      </template>
                    </div>
                  </div>
                  <div v-else-if="Array.isArray(item.new)">
                    <span v-for="(n, index) in item.new" :key="'new_' + index">
                      {{ n ?? '-' }}<span v-if="index < item.new.length - 1">, </span>
                    </span>
                  </div>
                  <span v-else>-</span>
                </template>
                <template v-slot:item.old="{ item }">
                   <span v-if="isSimpleValue(item.old)">
                    <template v-if="item.field === 'Mobile Number'">
                      {{ formatMobileNumber(item.old) }}
                    </template>
                    <template v-else>
                      {{ item.old ?? '-' }}
                    </template>
                  </span>
                  <div v-else-if="Array.isArray(item.old) && item.old.length && typeof item.old[0] === 'object'">
                    <div v-for="(entry, index) in item.old" :key="'old_' + index">
                      <strong>{{ entry.key }}</strong>: 
                      <template v-if="!isHtml(entry.value)">
                        <span>{{ entry.value ?? '-' }}</span>
                      </template>
                      <template v-else>
                        <div v-html="entry.value"></div>
                      </template>
                    </div>
                  </div>
                  <div v-else-if="Array.isArray(item.old)">
                    <span v-for="(n, index) in item.old" :key="'old_' + index">
                      {{ n ?? '-' }}<span v-if="index < item.old.length - 1">, </span>
                    </span>
                  </div>
                  <span v-else>-</span>
                </template>
              </hb-data-table>
            </div>
          </template>

          <template v-slot:left-actions>
            <span class="pl-3 pr-2" style="position:relative;top:-2px">
              <HbIcon
                color="#101318"
                small
                mdi-code="mdi-account-clock-outline"
              />
            </span>
            <span class="hb-font-caption">{{ modalData.userDateTime }}</span>
          </template>
        </hb-modal>
      </template>

      <hb-header full :divider="false">
        <hb-page-header
            title="Activity Tracker"
            description="Report of user activity and settings changes in Hummingbird."
        ></hb-page-header>
      </hb-header>

      <div>
         <hb-tabs v-model="activityTrackerTab">
          <v-tab v-for="tab in visibleTabs" :key="tab.type" :ripple="false">
            {{ tab.label }}
          </v-tab>
         </hb-tabs>
      </div>    

      <VDivider />
      <div class="mb-6" style="display:flex;flex-direction:column;flex:1;">

        <hb-data-table-header left-columns="11" right-columns="1">
            <template v-slot:description>
                <div>
                  This table displays <span class="hb-text-night hb-font-caption-medium">1000</span> records at a time. If the records you are searching for are not available, add filters to return a smaller result set 
                </div>
            </template>
            <template v-slot:actions>
                <hb-modal
                    v-if="currentTabType === 'user'"
                    v-model="filterModalUser"
                    title="Filter User Actions"
                    :show-help-link="false"
                >
                    <template v-slot:activator>
                        <hb-btn icon :active="filterModalUser" tooltip="Filter">mdi-filter-variant</hb-btn>
                         <v-badge v-if="getUserFilterLength" color="#F26500" :content="getUserFilterLength" offset-y="-5"
                          offset-x="15">
                        </v-badge>
                    </template>
                    <template v-slot:subheader>
                        Select or type in the options you would like to filter by
                    </template>
                    <template v-slot:content>
                        <hb-form label="Date Range">
                          <v-row no-gutters>
                            <v-col cols="6">
                              <hb-select
                               :items="date_range_select_user.items"
                               v-model="date_range_select_user.value"
                               item-text="label"
                               item-value="value"
                               placeholder="Select Range"
                              >
                              </hb-select>
                            </v-col>
                          </v-row>
                          <v-row v-if="date_range_select_user.value === 'custom'" no-gutters class="mt-n5 mb-n2">
                              <v-col cols="6" no-gutters>
                                  <hb-date-picker
                                      v-model="filterOptionsUserClone.start_date.value"
                                      @click:clear="filterOptionsUserClone.start_date.value = null"
                                      label="Select Start Date"
                                      :max="filterOptionsUserClone.end_date.value ? formatToLocalTimeStampObject(filterOptionsUserClone.end_date.value) : todaysDate"
                                      :single-line="true"
                                      :clearable="true"
                                      :solo="false"
                                      data-vv-name="start_date"
                                      data-vv-as="Start Date"
                                  ></hb-date-picker>
                              </v-col>
                              <v-col cols="6" no-gutters class="pl-3">
                                  <hb-date-picker
                                      v-model="filterOptionsUserClone.end_date.value"
                                      @click:clear="filterOptionsUserClone.end_date.value = null"
                                      label="Select End Date"
                                      :max="todaysDate"
                                      :min="filterOptionsUserClone.start_date.value ? formatToLocalTimeStampObject(filterOptionsUserClone.start_date.value) : ''"
                                      :single-line="true"
                                      :clearable="true"
                                      :solo="false"
                                      data-vv-name="end_date"
                                      data-vv-as="End Date"
                                  ></hb-date-picker>
                              </v-col>
                          </v-row>
                        </hb-form>
                        <hb-form label="User">
                          <hb-autocomplete
                            :items="adminUsers"
                            item-text="displayText"
                            item-value="displayText"
                            v-model="filterOptionsUserClone.user.value"
                            placeholder="Enter Name"
                            v-validate="'max:45'"
                            name="User"
                          />
                        </hb-form>
                        <hb-form label="Property">
                           <hb-autocomplete
                              :items="mappedProperties"
                              item-text="displayText"
                              item-value="id"
                              placeholder="Select or Enter Property Information"
                              v-model="filterOptionsUserClone.properties.value"
                              multiple
                            >
                          </hb-autocomplete>
                        </hb-form>
                        <hb-form label="Action">
                          <hb-autocomplete
                            v-model="filterOptionsUserClone.action.value"
                            :items="selectFilterOptions.userActions"
                            placeholder="Select Action"
                            name="Action"
                          />
                        </hb-form>
                        <hb-form label="Target">
                          <HbTextField
                            v-model="filterOptionsUserClone.target.value"
                            placeholder="Enter Target"
                            name="Target"
                          />
                        </hb-form>
                        <hb-form label="IP Address" last>
                          <HbTextField
                            v-model="filterOptionsUserClone.ip_address.value"
                            placeholder="Enter IP Address"
                            v-validate="'max:45'"
                            name="IP Address"
                          />
                        </hb-form>
                    </template>
                    <template v-slot:left-actions>
                        <hb-link v-if="hasFiltersUser && !loadingAudits" @click="resetFiltersUser()">Reset Filters</hb-link>
                    </template>
                    <template v-slot:right-actions>
                        <hb-btn @click="goFilterUser()">Filter</hb-btn>
                    </template>
                </hb-modal>

                <hb-modal
                    v-else
                    v-model="filterModalSettings"
                    title="Filter Settings Changes"
                    :show-help-link="false"
                >
                    <template v-slot:activator>
                        <hb-btn icon :active="filterModalSettings" tooltip="Filter">mdi-filter-variant</hb-btn>
                        <v-badge v-if="getSettingsFilterLength" color="#F26500" :content="getSettingsFilterLength" offset-y="-5"
                          offset-x="15">
                        </v-badge>
                    </template>
                    <template v-slot:subheader>
                        Select or type in the options you would like to filter by
                    </template>
                    <template v-slot:content>
                        <hb-form label="Date Range">
                           <v-row no-gutters>
                              <v-col cols="6">
                                <hb-select
                                :items="date_range_select_settings.items"
                                v-model="date_range_select_settings.value"
                                item-text="label"
                                item-value="value"
                                placeholder="Select Range"
                                >
                                </hb-select>
                              </v-col>
                          </v-row>
                          <v-row v-if="date_range_select_settings.value === 'custom'" no-gutters class="mt-n5 mb-n2">
                              <v-col cols="6" no-gutters>
                                  <hb-date-picker
                                      v-model="filterOptionsSettingsClone.start_date.value"
                                      @click:clear="filterOptionsSettingsClone.start_date.value = null"
                                      label="Select Start Date"
                                      :max="filterOptionsSettingsClone.end_date.value ? formatToLocalTimeStampObject(filterOptionsSettingsClone.end_date.value) : todaysDate"
                                      :single-line="true"
                                      :clearable="true"
                                      :solo="false"
                                      data-vv-name="start_date"
                                      data-vv-as="Start Date"
                                  ></hb-date-picker>
                              </v-col>
                              <v-col cols="6" no-gutters class="pl-3">
                                  <hb-date-picker
                                      v-model="filterOptionsSettingsClone.end_date.value"
                                      @click:clear="filterOptionsSettingsClone.end_date.value = null"
                                      label="Select End Date"
                                      :max="todaysDate"
                                      :min="filterOptionsSettingsClone.start_date.value ? formatToLocalTimeStampObject(filterOptionsSettingsClone.start_date.value) : ''"
                                      :single-line="true"
                                      :clearable="true"
                                      :solo="false"
                                      data-vv-name="end_date"
                                      data-vv-as="End Date"
                                  ></hb-date-picker>
                              </v-col>
                          </v-row>
                        </hb-form>
                        <hb-form label="User">
                          <hb-autocomplete
                            :items="adminUsers"
                            item-text="displayText"
                            item-value="displayText"
                            v-model="filterOptionsSettingsClone.user.value"
                            placeholder="Enter Name"
                            v-validate="'max:45'"
                            name="User"
                          />
                        </hb-form>
                        <hb-form label="Property">
                           <hb-autocomplete
                              :items="mappedProperties"
                              item-text="displayText"
                              item-value="id"
                              placeholder="Select or Enter Property Information"
                              v-model="filterOptionsSettingsClone.properties.value"
                              multiple
                            >
                          </hb-autocomplete>
                        </hb-form>
                        <hb-form label="Setting">
                          <HbSelect
                            v-model="filterOptionsSettingsClone.setting.value"
                            :items="selectFilterOptions.settings"
                            placeholder="Select Setting"
                            name="Setting"
                          />
                        </hb-form>
                        <hb-form label="Sub-setting">
                          <HbSelect
                            v-model="filterOptionsSettingsClone.sub_setting.value"
                            :items="selectFilterOptions.subSettings"
                            placeholder="Select Sub-setting"
                            name="Sub-setting"
                          />
                        </hb-form>
                        <hb-form label="Change">
                          <HbSelect
                            v-model="filterOptionsSettingsClone.change.value"
                            :items="selectFilterOptions.settingsActions"
                            placeholder="Select Change"
                            v-validate="'max:45'"
                            name="Change"
                          />
                        </hb-form>
                        <hb-form label="Target">
                          <HbTextField
                            v-model="filterOptionsSettingsClone.target.value"
                            placeholder="Target"
                            v-validate="'max:45'"
                            name="Target"
                          />
                        </hb-form>
                        <hb-form label="IP Address" last>
                          <HbTextField
                            v-model="filterOptionsSettingsClone.ip_address.value"
                            placeholder="Enter IP Address"
                            v-validate="'max:45'"
                            name="IP Address"
                          />
                        </hb-form>
                    </template>
                    <template v-slot:left-actions>
                      <hb-link v-if="hasFiltersSettings && !loadingAudits" @click="resetFiltersSettings()">Reset Filters</hb-link>
                    </template>
                    <template v-slot:right-actions>
                        <hb-btn @click="goFilterSettings()">Filter</hb-btn>
                    </template>
                </hb-modal>
            </template>
        </hb-data-table-header>
          <div style="position: relative;flex:1">
            <hb-data-table
              :headers="currentTabType === 'user' ? userHeaders : settingsHeaders"
              :items="audits"
              :loading="loadingAudits"
              loading-text="Loading Activities..."
              class="mb-3 fixed-footer-table"
              style="position: absolute;top:0;left:0;height:100%;width:100%;"
              @click:row="openModal">

              <template v-slot:no-data>
        `       <div class="hb-font-header-3-medium">No Results found</div>
              </template>`

            <template v-slot:item.timestamp="{ item }">
               {{ item.timestamp | formatDateTime }}
            </template>

            <template v-slot:footer>
              <v-row no-gutters class="px-4 activity-tracker-table-footer-wrapper">
                  
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? 8 : 10" no-gutters class="d-flex align-top">
                      <div class="hb-font-caption pr-1 pt-4" style="min-width: 120px;">
                          Records: <span class="font-weight-medium">{{ auditCount }}</span>
                          <span v-if="auditCount >= 1000" class="pl-1" style="position:relative;top:-1px;">
                            <hb-tooltip max-width="250">
                              <template v-slot:body>
                                  The viewer can only display <span class="font-weight-medium">1000</span> records. If the record you are searching for is not visible, add filters or perform a search to return a smaller result set.
                              </template>
                            </hb-tooltip>
                          </span>
                      </div>
                      <div v-if="currentTabType === 'user'" class="activity-tracker-display-inline py-2" style="position:relative;top:.5px;">
                          <div v-if="filterOptionsUser.start_date.value && filterOptionsUser.end_date.value" class="activity-tracker-display-inline">
                              <hb-chip
                                  :editable="!loadingAudits"
                                  @click="goFilterUser(null, 'date_range')"
                              >
                                  <div class="d-flex align-center">
                                      <div v-if="filterOptionsUser.start_date.value">{{ formatToLocalTimeStamp(filterOptionsUser.start_date.value) }}</div>
                                      <div v-if="filterOptionsUser.start_date.value && filterOptionsUser.end_date.value" class="px-1">-</div>
                                      <div v-if="filterOptionsUser.end_date.value">{{ formatToLocalTimeStamp(filterOptionsUser.end_date.value) }}</div>
                                  </div>
                              </hb-chip>
                          </div>
                          <div
                            v-for="item in filterOptionsUser"
                            :key="'user_type_filter' + item.name"
                            class="activity-tracker-display-inline"
                          >
                              <hb-chip
                                v-if="item.value && item.param !== 'start_date' && item.param !== 'end_date'"
                                :editable="!loadingAudits"
                                @click="goFilterUser(item.param)"
                              >
                                {{ item.param !== 'properties' ? item.value : selectedPropertiesMapped(item.value) }}
                              </hb-chip>
                          </div>
                      </div>
                      <div v-else class="activity-tracker-display-inline py-2" style="position:relative;top:.5px;">
                          <div v-if="filterOptionsSettings.start_date.value && filterOptionsSettings.end_date.value" class="activity-tracker-display-inline">
                              <hb-chip
                                  :editable="!loadingAudits"
                                  @click="goFilterSettings(null, 'date_range')"
                              >
                                  <div class="d-flex align-center">
                                      <div v-if="filterOptionsSettings.start_date.value">{{ formatToLocalTimeStamp(filterOptionsSettings.start_date.value) }}</div>
                                      <div v-if="filterOptionsSettings.start_date.value && filterOptionsSettings.end_date.value" class="px-1">-</div>
                                      <div v-if="filterOptionsSettings.end_date.value">{{ formatToLocalTimeStamp(filterOptionsSettings.end_date.value) }}</div>
                                  </div>
                              </hb-chip>
                          </div>
                          <div
                            v-for="item in filterOptionsSettings"
                            :key="'settings_type_filter' + item.name"
                            class="activity-tracker-display-inline"
                          >
                              <hb-chip
                                v-if="item.value && item.param !== 'start_date' && item.param !== 'end_date'"
                                :editable="!loadingAudits"
                                @click="goFilterSettings(item.param)"
                              >
                                {{ item.param !== 'properties' ? item.value : selectedPropertiesMapped(item.value) }}
                              </hb-chip>
                          </div>
                      </div>
                  </v-col>
                  <v-col v-if="currentTabType === 'user' &&  hasFiltersUser && !loadingAudits" :cols="$vuetify.breakpoint.smAndDown ? 4 : 2" no-gutters class="py-3" align="right">
                      <hb-btn small color="secondary" @click="resetFiltersUser()">Reset Filters</hb-btn>
                  </v-col>
                  <v-col v-else-if="currentTabType === 'settings' && hasFiltersSettings && !loadingAudits" :cols="$vuetify.breakpoint.smAndDown ? 4 : 2" no-gutters class="py-3" align="right">
                      <hb-btn small color="secondary" @click="resetFiltersSettings()">Reset Filters</hb-btn>
                  </v-col>
              </v-row>
          </template>

          </hb-data-table>
          </div>
      </div>

    </div>
  </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions } from 'vuex';
import api from '../../assets/api.js';
import moment from 'moment';
import { notificationMixin } from  '../../mixins/notificationMixin.js';
import HbDatePicker from '../assets/HummingbirdDatepicker';
import { parsePhoneNumber } from 'libphonenumber-js';
function mapPropertiesOnDisplayText(properties){
    return properties.map(p => {
        const parts = []

        if (p.number) parts.push(p.number)
        if (p?.Address?.city) parts.push(p.Address.city)
        if (p?.Address?.address) parts.push(p.Address.address)

        return {
          ...p,
          displayText: parts.join(' - ')
        }
      })
  }
const countValidFilters = filters => {
      const isValid = val =>
        val !== null &&
        val !== undefined &&
        !(typeof val === 'string' && val.trim() === '');

      const normalCount = Object.entries(filters)
        .filter(([key]) => key !== 'start_date' && key !== 'end_date')
        .filter(([, { value }]) => isValid(value))
        .length;
      const dateRangeValid = isValid(filters.start_date?.value) && isValid(filters.end_date?.value) ? 1 : 0;
      return normalCount + dateRangeValid;
    };

export default {
  name: "ActivityTracker",
  mixins: [notificationMixin],
  modalData: {
    type: Object,
    required: true
  },
  data() {
    return {
      adminUsers:[],
      isModalVisible: false,
      modalData: {
        data: {},
        modified_data: {},
        // entityText: '',
        userDateTime: ''
      },
      audits: [],
      auditCount: 0,
      loadingAudits: false,
      userHeaders: [
        {text: 'Timestamp', value: 'timestamp'},
        {text: 'User', value: 'user'},
        {text: 'Property', value: 'property_name'},
        {text: 'Action', value: 'action'},
        {text: 'Target', value: 'entity_name'},
        {text: 'IP Address', value: 'ip_address'},
      ],
      settingsHeaders: [
        {text: 'Timestamp', value: 'timestamp'},
        {text: 'User', value: 'user'},
        {text: 'Property', value: 'property_name'},
        {text: 'Setting', value: 'entity'},
        {text: 'Sub-setting', value: 'sub_entity'},
        {text: 'Target', value: 'entity_name'},
        {text: 'Change', value: 'action'},
        {text: 'IP Address', value: 'ip_address'},
      ],
      activityTrackerTab: 0,
      modalHeaders: [
        {text: 'Item', value: 'field'},
        {text: 'Changed To', value: 'new', sortable: false,},
        {text: 'Changed From', value: 'old', sortable: false,},
      ],
      date_range_select_user: {
          param: 'date_range',
          name: 'Date Range',
          items: [{
            "label": 'Yesterday',
            "value": "yesterday"
          }, {
            "label": 'Last 7 Days',
            "value": "last_7_days"
          }, {
            "label": 'Last 30 Days',
            "value": "last_30_days"
          },
          {
            "label": 'Custom',
            "value": "custom"
          }
          ],
          value: null
        },
      date_range_select_settings:{ //avoid duplicates later
          param: 'date_range',
          name: 'Date Range',
          items: [{
            "label": 'Yesterday',
            "value": "yesterday"
          }, {
            "label": 'Last 7 Days',
            "value": "last_7_days"
          }, {
            "label": 'Last 30 Days',
            "value": "last_30_days"
          },
          {
            "label": 'Custom',
            "value": "custom"
          }
          ],
          value: null
        },
      filterModalUser: false,
      filterOptionsUser: {
        start_date: {
          param: 'start_date',
          name: 'Start Date',
          value: null
        },
        end_date: {
          param: 'end_date',
          name: 'End Date',
          value: null
        },
        user: {
          param: 'user',
          name: 'User',
          value: null
        },
         properties: {
          param: 'properties',
          name: 'Properties',
          value: null
        },
        action: {
          param: 'action',
          name: 'Action',
          value: null
        },
        target: {
          param: 'target',
          name: 'Target',
          value: null
        },
        ip_address: {
          param: 'ip_address',
          name: 'IP Address',
          value: null
        }
      },
      filterOptionsUserClone: {
        start_date: {
          param: 'start_date',
          name: 'Start Date',
          value: null
        },
        end_date: {
          param: 'end_date',
          name: 'End Date',
          value: null
        },
        user: {
          param: 'user',
          name: 'User',
          value: null
        },
        properties: {
          param: 'properties',
          name: 'Properties',
          value: null
        },
        action: {
          param: 'action',
          name: 'Action',
          value: null
        },
        target: {
          param: 'target',
          name: 'Target',
          value: null
        },
        ip_address: {
          param: 'action',
          name: 'Action',
          value: null
        }
      },
      filterModalSettings: false,
      filterOptionsSettings: {
        start_date: {
          param: 'start_date',
          name: 'Start Date',
          value: null
        },
        end_date: {
          param: 'end_date',
          name: 'End Date',
          value: null
        },
        user: {
          param: 'user',
          name: 'User',
          value: null
        },
        properties: {
          param: 'properties',
          name: 'Properties',
          value: null
        },
        setting: {
          param: 'setting',
          name: 'setting',
          value: null
        },
        sub_setting: {
          param: 'sub_setting',
          name: 'Sub-setting',
          value: null
        },
        change: {
          param: 'change',
          name: 'Change',
          value: null
        },
        target: {
          param: 'target',
          name: 'Target',
          value: null
        },
        ip_address: {
          param: 'ip_address',
          name: 'IP Address',
          value: null
        }
      },
      filterOptionsSettingsClone: {
        start_date: {
          param: 'start_date',
          name: 'Start Date',
          value: null
        },
        end_date: {
          param: 'end_date',
          name: 'End Date',
          value: null
        },
         properties: {
          param: 'properties',
          name: 'Properties',
          value: null
        },
        user: {
          param: 'user',
          name: 'User',
          value: null
        },
        setting: {
          param: 'setting',
          name: 'setting',
          value: null
        },
        sub_setting: {
          param: 'sub_setting',
          name: 'Sub-setting',
          value: null
        },
        change: {
          param: 'change',
          name: 'Change',
          value: null
        },
        target: {
          param: 'target',
          name: 'Target',
          value: null
        },
        ip_address: {
          param: 'ip_address',
          name: 'IP Address',
          value: null
        }
      },
      todaysDate: '',
      modifiedDataArray: [],
      userActionsSearch: '',
      settingsChangesSearch: '',
      selectFilterOptions: {
        "settings": [],
        "subSettings": [],
        "settingsActions": [],
        "userActions": [],
        "settingsMap": {}
      }
    }
  },
  components:{
    HbDatePicker
  },
  mounted() {
    this.todaysDate = moment().format('YYYY-MM-DD');
    this.fetchAuditData();
    api.get(this, api.ADMIN + 'active/users').then(response =>{
      this.adminUsers = response.admins?.map(admin =>{
        return {...admin, ...{displayText:`${admin.first} ${admin.last}`}}
      })
    }).catch(e=>{
      this.showMessageNotification({ type: 'error', description: 'An error has occurred in retrieving users. Please refresh and try again or contact support.' });
    })
    this.fetchFilterData();
    
  },
  computed: {
    ...mapGetters({
      isAdmin: 'authenticationStore/isAdmin',
      properties: 'propertiesStore/filtered',
      getUserData: 'authenticationStore/getUserData',
      hasPermission: 'authenticationStore/rolePermission',
      selectedProperties: "propertiesStore/filtered"
    }),
    mappedProperties(){
      return mapPropertiesOnDisplayText(this.selectedProperties)
    },
    canViewUserActions() {
      return this.hasPermission && this.hasPermission('view_activity_tracker_user_actions');
    },
    canViewSettings() {
      return this.hasPermission && this.hasPermission('view_activity_tracker_settings');
    },
    visibleTabs() {
      const tabs = [];
      if (this.canViewUserActions) tabs.push({ label: 'User Actions', type: 'user' });
      if (this.canViewSettings) tabs.push({ label: 'Settings Changes', type: 'settings' });
      return tabs;
    },
    currentTabType() {
      return this.visibleTabs[this.activityTrackerTab]?.type;
    },
    getUserFilterLength(){      
        return countValidFilters(this.filterOptionsUser)
    },
    getSettingsFilterLength(){      
        return countValidFilters(this.filterOptionsSettings)
    },
    hasFiltersUser(){
      for (var item in this.filterOptionsUser) {
          if(this.filterOptionsUser[item].value){
              return true;
          }
      }
      return false;
    },
    hasFiltersSettings(){
      for (var item in this.filterOptionsSettings) {
          if(this.filterOptionsSettings[item].value){
              return true;
          }
      }
      return false;
    },
  },
  methods: {
  formatMobileNumber(value) {
      if (!value) return '';
      try {
        var parsedPhoneNumber = parsePhoneNumber('+' + value);

        if (parsedPhoneNumber && parsedPhoneNumber.isValid()) {
          if (parsedPhoneNumber.country === 'US') {
            return '+1 ' + parsedPhoneNumber.formatNational();
          } else {
            return parsedPhoneNumber.formatInternational();
          }
        } else {
          value = value.toString();

          var numbers = value.replace(/\D/g, ''), char = { 0: '(', 3: ') ', 6: '-' };
          value = '';
          for (var i = 0; i < numbers.length; i++) {
            value += (char[i] || '') + numbers[i];
          }
        }
      } catch (err) {
      }
      return value;
    },
  formatToLocalTimeStampObject(value){
    return moment.utc(value).local().format('YYYY-MM-DDTHH:mm:ss[Z]')
  },
  formatToLocalTimeStamp(value){
      return moment.utc(value).local().format('MMM D, YYYY')
  },
  selectedPropertiesMapped(value){
      return Array.isArray(value) ? this.mappedProperties
      .filter(p => value.includes(p.id))
      .map(p => p.displayText)
      .join(', ') : ''
    },
    async fetchFilterData() {
        try {
          const response = await api.get(this, api.FILTERS)
          this.selectFilterOptions = response?.filters;
        } catch (error) { 
          this.showMessageNotification({ type: 'error', description: 'An error has ocurred in retrieving actions. Please try again later or contact the Customer Success team if the issue persists.' });
        } 
      },
    async fetchAuditData() {
      this.loadingAudits = true;

      if(this.currentTabType === 'user'){
        let data = {
          "filters": {
            "category": "User Actions",
            "user": this.filterOptionsUser.user.value,
            "action": this.filterOptionsUser.action.value,
            "ip_address": this.filterOptionsUser.ip_address.value,
            'property_id': this.filterOptionsUser.properties.value,
            'entity_name': this.filterOptionsUser.target.value
          } 
        }
        if(this.filterOptionsUser.start_date.value && this.filterOptionsUser.end_date.value){
          data.date_range = {
            "from": this.filterOptionsUser.start_date.value || null,
            "to": this.filterOptionsUser.end_date.value || null,
          }
        }

        if(this.userActionsSearch){
          data.search = {
            "field": "modified_data",
            "value": this.userActionsSearch
          }
        }

        try {
        
          let response = await api.post(this, api.AUDITING, data);
          console.log('Response:', JSON.stringify(response));
          this.audits = response.auditResults;

          this.auditCount = response.count;
        } catch (error) {
          this.showMessageNotification({ type: 'error', description: 'An error has ocurred in retrieving activities. Please try again later or contact the Customer Success team if the issue persists.' });
        } finally {
          this.loadingAudits = false;
        }
      } else {
        let data = {
          "filters": {
            "category": "Settings",
            "user": this.filterOptionsSettings.user.value,
            "entity": this.filterOptionsSettings.setting.value,
            "sub_entity": this.filterOptionsSettings.sub_setting.value,
            "action": this.filterOptionsSettings.change.value,
            "ip_address": this.filterOptionsSettings.ip_address.value,
            'property_id': this.filterOptionsSettings.properties.value,
            'entity_name': this.filterOptionsSettings.target.value
          } 
        }

        if(this.filterOptionsSettings.start_date.value && this.filterOptionsSettings.end_date.value){
          data.date_range = {
            "from": this.filterOptionsSettings.start_date.value || null,
            "to": this.filterOptionsSettings.end_date.value || null,
          }
        }

        if(this.settingsChangesSearch){
          data.search = {
            "field": "modified_data",
            "value": this.settingsChangesSearch
          }
        }

        try {
        
          let response = await api.post(this, api.AUDITING, data);
          console.log('Response:', JSON.stringify(response));
          this.audits = response.auditResults;

          this.auditCount = response.count;
        } catch (error) {
          this.showMessageNotification({ type: 'error', description: 'An error has ocurred in retrieving activities. Please try again later or contact the Customer Success team if the issue persists.' });
        } finally {
          this.loadingAudits = false;
        }
      }
    },
    isSimpleValue(value) {
      // Check if the value is a simple value (not an array or object)
      return !Array.isArray(value);
    },
    openModal(item) {
      console.log('Row clicked:', item);
      this.modifiedDataArray = [];

      this.modifiedDataArray = Object.entries(item.modified_data).map(([field, values]) => ({
        field,
        ...values
      }));

      this.modalData = {
        data: item,
        modified_data: this.modifiedDataArray || [],
        // entityText: `${item.entity} > ${this.getEntityText(item)}`,
        userDateTime: this.getUserDateTime(item)
      };

      this.isModalVisible = true;
    },

    closeModal() {
      this.isModalVisible = false;
      this.modifiedDataArray = [];
      this.modalData = {
        data: {},
        modified_data: [],
        // entityText: '',
        userDateTime: ''
      };
    },
    /*
    getEntityText(item) {
      switch (item.action) {
        case 'Create':
          return `Added: ${item.entity_name}`;
        case 'Update':
          return `Modified: ${item.entity_name}`;
        case 'Delete':
          return `Deleted: ${item.entity_name}`;
        case 'Payment':
          return `Payment processed: ${item.entity_name}`;
        default:
          return `${item.action || 'Unknown'}: ${item.entity_name || 'Entity'}`; // Fallback for undefined action/entity_name
      }
    },
    */
    getUserDateTime(item) {
      const formattedTime = this.$options.filters.formatDateTime(item.timestamp) ;
      return `${item.user} ( ${formattedTime} )`;
    },

    goFilterUser(type, special){
      if(type){
        this.filterOptionsUserClone[type].value = null;
      } 
      if (
        special && special === 'date_range' ||
        (!this.filterOptionsUserClone.start_date.value && this.filterOptionsUserClone.end_date.value) ||
        (this.filterOptionsUserClone.start_date.value && !this.filterOptionsUserClone.end_date.value)
      ) {
        this.date_range_select_user.value = null;
        this.filterOptionsUserClone.start_date.value = null;
        this.filterOptionsUserClone.end_date.value = null;
      }
      this.filterOptionsUser = JSON.parse(JSON.stringify(this.filterOptionsUserClone));
      this.filterModalUser = false;
      this.resetAudits();
      this.fetchAuditData();
    },

    goFilterSettings(type, special){
       if (
        special && special === 'date_range' ||
        (!this.filterOptionsSettingsClone.start_date.value && this.filterOptionsSettingsClone.end_date.value) ||
        (this.filterOptionsSettingsClone.start_date.value && !this.filterOptionsSettingsClone.end_date.value)
      ) {
        this.date_range_select_settings.value = null;
        this.filterOptionsSettingsClone.start_date.value = null;
        this.filterOptionsSettingsClone.end_date.value = null;
      }
      if(type){
        this.filterOptionsSettingsClone[type].value = null;
      } 
      this.filterOptionsSettings = JSON.parse(JSON.stringify(this.filterOptionsSettingsClone));
      this.filterModalSettings = false;
      this.resetAudits();
      this.fetchAuditData();
    },

    resetFiltersUser(){
      this.date_range_select_user = {
          param: 'date_range',
          name: 'Date Range',
          items: [{
            "label": 'Yesterday',
            "value": "yesterday"
          }, {
            "label": 'Last 7 Days',
            "value": "last_7_days"
          }, {
            "label": 'Last 30 Days',
            "value": "last_30_days"
          },
          {
            "label": 'Custom',
            "value": "custom"
          }
          ],
          value: null
        }
      this.filterOptionsUser = {
        start_date: {
          param: 'start_date',
          name: 'Start Date',
          value: null
        },
        end_date: {
          param: 'end_date',
          name: 'End Date',
          value: null
        },
        user: {
          param: 'user',
          name: 'User',
          value: null
        },
        properties: {
          param: 'properties',
          name: 'Properties',
          value: null
        },
        action: {
          param: 'action',
          name: 'Action',
          value: null
        },
        target: {
          param: 'target',
          name: 'Target',
          value: null
        },
        ip_address: {
          param: 'ip_address',
          name: 'IP Address',
          value: null
        }
      }

      if(this.filterModalUser){
          this.filterModalUser = false;
      }
      this.resetAudits();
      this.fetchAuditData();
    },

    resetFiltersSettings(){
      this.date_range_select_settings = {
          param: 'date_range',
          name: 'Date Range',
          items: [{
            "label": 'Yesterday',
            "value": "yesterday"
          }, {
            "label": 'Last 7 Days',
            "value": "last_7_days"
          }, {
            "label": 'Last 30 Days',
            "value": "last_30_days"
          },
          {
            "label": 'Custom',
            "value": "custom"
          }
          ],
          value: null
        }
      this.filterOptionsSettings = {
        start_date: {
          param: 'start_date',
          name: 'Start Date',
          value: null
        },
        end_date: {
          param: 'end_date',
          name: 'End Date',
          value: null
        },
        user: {
          param: 'user',
          name: 'User',
          value: null
        },
        properties: {
          param: 'properties',
          name: 'Properties',
          value: null
        },
        setting: {
          param: 'setting',
          name: 'setting',
          value: null
        },
        sub_setting: {
          param: 'sub_setting',
          name: 'Sub-setting',
          value: null
        },
        change: {
          param: 'change',
          name: 'Change',
          value: null
        },
        target: {
          param: 'action',
          name: 'Action',
          value: null
        },
        ip_address: {
          param: 'ip_address',
          name: 'IP Address',
          value: null
        }
      }

      if(this.filterModalSettings){
          this.filterModalSettings = false;
      }
      this.resetAudits();
      this.fetchAuditData();
    },

    searchUser:  _.debounce(function() {
      this.resetAudits();
      this.fetchAuditData();
    }, 1000),

    searchSettings:  _.debounce(function() {
      this.resetAudits();
      this.fetchAuditData();
    }, 1000),

    resetAudits(){
      this.audits = [];
      this.auditCount = 0;
    },

    isHtml(value) {
      return typeof value === 'string' && /<\/?[a-z][\s\S]*>/i.test(value);
    }

  },
  watch: {
    canViewUserActions: {
      immediate: true,
      handler(val) {
        if (this.visibleTabs.length > 0 && this.activityTrackerTab >= this.visibleTabs.length) {
          this.activityTrackerTab = 0;
        }
      }
    },
    canViewSettings: {
      immediate: true,
      handler(val) {
        if (this.visibleTabs.length > 0 && this.activityTrackerTab >= this.visibleTabs.length) {
          this.activityTrackerTab = 0;
        }
      }
    },
    activityTrackerTab(val) {
      if (this.visibleTabs.length > 0 && val >= this.visibleTabs.length) {
        this.activityTrackerTab = 0;
      }
    },
    'date_range_select_user.value'(newVal){
        let startDateString = null;
        let endDateString = null;
        const selected = newVal;
        if (selected === 'yesterday') {
          // Get yesterday in local timezone
          const startLocal = moment().subtract(1, 'day').startOf('day') // 00:00:00 local
          const endLocal = moment().subtract(1, 'day').endOf('day')    // 23:59:59 local
          
          // Convert to UTC
          const startUTC = startLocal.clone().utc()
          const endUTC = endLocal.clone().utc()

          startDateString = startUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
          endDateString = endUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
        } else if (selected === 'last_7_days') {
          // Last 7 full days
          const start7DaysLocal = moment().subtract(7, 'days').startOf('day'); // 7 days ago
          const end7DaysLocal = moment().subtract(1, 'day').endOf('day');      // yesterday

          // Convert to UTC
          const start7DaysUTC = start7DaysLocal.clone().utc();
          const end7DaysUTC = end7DaysLocal.clone().utc();
          startDateString = start7DaysUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
          endDateString = end7DaysUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
        } else if (selected === 'last_30_days') {
          // Last 30 full days
          const start30DaysLocal = moment().subtract(30, 'days').startOf('day') // 30 days ago
          const end30DaysLocal = moment().subtract(1, 'day').endOf('day')      // yesterday

          // Convert to UTC
          const start30DaysUTC = start30DaysLocal.clone().utc()
          const end30DaysUTC = end30DaysLocal.clone().utc()
          startDateString = start30DaysUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
          endDateString = end30DaysUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
        }else {
          this.filterOptionsUserClone.start_date.value = null
          this.filterOptionsUserClone.end_date.value = null
        }
        if(startDateString && endDateString){
          this.filterOptionsUserClone.start_date.value = startDateString
          this.filterOptionsUserClone.end_date.value = endDateString
        }
    },
    'date_range_select_settings.value'(newVal){
        //code to optimise
        let startDateString = null;
        let endDateString = null;
        const selected = newVal;
        if (selected === 'yesterday') {
          // Get yesterday in local timezone
          const startLocal = moment().subtract(1, 'day').startOf('day') // 00:00:00 local
          const endLocal = moment().subtract(1, 'day').endOf('day')    // 23:59:59 local
          
          // Convert to UTC
          const startUTC = startLocal.clone().utc()
          const endUTC = endLocal.clone().utc()

          startDateString = startUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
          endDateString = endUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
        } else if (selected === 'last_7_days') {
          // Last 7 full days
          const start7DaysLocal = moment().subtract(7, 'days').startOf('day'); // 7 days ago
          const end7DaysLocal = moment().subtract(1, 'day').endOf('day');      // yesterday

          // Convert to UTC
          const start7DaysUTC = start7DaysLocal.clone().utc();
          const end7DaysUTC = end7DaysLocal.clone().utc();
          startDateString = start7DaysUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
          endDateString = end7DaysUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
        } else if (selected === 'last_30_days') {
          // Last 30 full days
          const start30DaysLocal = moment().subtract(30, 'days').startOf('day') // 30 days ago
          const end30DaysLocal = moment().subtract(1, 'day').endOf('day')      // yesterday

          // Convert to UTC
          const start30DaysUTC = start30DaysLocal.clone().utc()
          const end30DaysUTC = end30DaysLocal.clone().utc()
          startDateString = start30DaysUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
          endDateString = end30DaysUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
        }else {
          this.filterOptionsSettingsClone.start_date.value = null
          this.filterOptionsSettingsClone.end_date.value = null
        }
        if(startDateString && endDateString){
          this.filterOptionsSettingsClone.start_date.value = startDateString
          this.filterOptionsSettingsClone.end_date.value = endDateString
        }
    },
    'filterOptionsUserClone.start_date.value'(newVal){
      if(newVal){
        const startDateLocal = moment(newVal).startOf('day') // 00:00:00 local time
        const startDateUTC = startDateLocal.clone().utc()
        this.filterOptionsUserClone.start_date.value = startDateUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
      }
    },
    'filterOptionsUserClone.end_date.value'(newVal){
      if(newVal){
          const endDateLocal = moment(newVal).endOf('day')
          const endDateUTC = endDateLocal.clone().utc();
          this.filterOptionsUserClone.end_date.value = endDateUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
      }
    },
      'filterOptionsSettingsClone.start_date.value'(newVal){
        if(newVal){
          const startDateLocal = moment(newVal).startOf('day') // 00:00:00 local time
          const startDateUTC = startDateLocal.clone().utc()
          this.filterOptionsSettingsClone.start_date.value = startDateUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
        }
    },
    'filterOptionsSettingsClone.end_date.value'(newVal){
          if(newVal){
            const endDateLocal = moment(newVal).endOf('day')
            const endDateUTC = endDateLocal.clone().utc();
            this.filterOptionsSettingsClone.end_date.value = endDateUTC.format('YYYY-MM-DDTHH:mm:ss[Z]')
          }
    },
    'filterOptionsUserClone.properties.value'(newVal) {
      if(Array.isArray(newVal) && newVal.length === 0)
        this.filterOptionsUserClone.properties.value = null
    },
    'filterOptionsSettingsClone.properties.value'(newVal) {
      if(Array.isArray(newVal) && newVal.length === 0)
        this.filterOptionsSettingsClone.properties.value = null
    },
    currentTabType(){
      this.resetAudits();
      this.fetchAuditData();
    },
    filterModalUser(){
      if(this.filterModalUser){
          this.filterOptionsUserClone = JSON.parse(JSON.stringify(this.filterOptionsUser));
      }
    },
    filterModalSettings(){
      if(this.filterModalSettings){
          this.filterOptionsSettingsClone = JSON.parse(JSON.stringify(this.filterOptionsSettings));
      }
    },
    'filterOptionsSettingsClone.setting.value'(newSetting) {
      (this.selectFilterOptions.settingsMap[newSetting] || []).sort();
      this.selectFilterOptions.subSettings = this.selectFilterOptions.settingsMap[newSetting] || [];
      this.filterOptionsSettingsClone.sub_setting.value = null;
    }
  }
}



</script>

<style scoped>
.fixed-footer-table ::v-deep(.hb-data-table-border){
  height: 100%;
}
.fixed-footer-table ::v-deep(.hb-data-table-wrapper){
  height: 100%;
}
.fixed-footer-table ::v-deep(.v-data-table__wrapper){
  height: calc(100% - 50px);
  overflow-y: auto;
}
.fixed-footer-table ::v-deep(thead th) {
  position: sticky;
  top: 0;
  background: #F4F6F8;
  z-index: 2;
}
.primary-section-content {
  display: flex;
  flex-direction: column;
}
.activity-tracker-display-inline {
  display: inline;
}

.activity-tracker-table-footer-wrapper {
  position: sticky;
  bottom: 0;
  background: white;
  z-index: 2;
  min-height: 50px;
  border: 1px solid #DFE3E8;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

</style>